import * as React from 'react';
import { Col, Row, Tooltip, Typography } from 'antd';
import { BsQuestionCircle } from 'react-icons/bs';
import './index.less';
import { useFormikContext } from 'formik';

export interface IFormItemProps {
  name?: string;
  layoutHorizontal?: boolean;
  span?: number;
  label?: string;
  isTooltip?: boolean;
  titleTooltip?: string;
  isNotForm?: boolean;
  fieldCommponent: React.ReactElement;
  labelSpan?: number;
}

interface FormItemContentProps extends IFormItemProps {
  errorMessage?: unknown;
}

const FormItemContent = ({
  label,
  layoutHorizontal,
  isTooltip,
  titleTooltip,
  isNotForm,
  fieldCommponent,
  span,
  labelSpan,
  errorMessage,
}: FormItemContentProps) => (
  <Row>
    {layoutHorizontal ? (
      <>
        <Col span={24}>
          <div>
            <Typography.Title level={5} className='inline-block'>
              {label} &nbsp;
            </Typography.Title>
            {isTooltip && (
              <Tooltip title={titleTooltip}>
                <BsQuestionCircle />
              </Tooltip>
            )}
          </div>
        </Col>
        <Col span={22} className='break-validations'>
          <div>{fieldCommponent}</div>
          {!isNotForm && typeof errorMessage === 'string' && (
            <Typography.Text type='danger'>{errorMessage}</Typography.Text>
          )}
        </Col>
      </>
    ) : (
      <>
        <Col span={labelSpan ?? 6}>
          <div className='title'>
            <Typography.Title level={5} className='inline-block'>
              {label} &nbsp;
            </Typography.Title>
            {isTooltip && (
              <Tooltip title={titleTooltip}>
                <BsQuestionCircle />
              </Tooltip>
            )}
          </div>
        </Col>
        <Col span={span ?? 14} className='break-validations'>
          <div>{fieldCommponent}</div>
          {!isNotForm && typeof errorMessage === 'string' && (
            <Typography.Text type='danger'>{errorMessage}</Typography.Text>
          )}
        </Col>
      </>
    )}
  </Row>
);

const FormikFormItem = (props: IFormItemProps) => {
  const { errors } = useFormikContext<Record<string, unknown>>();
  const errorMessage = props.name ? errors[props.name] : undefined;

  return <FormItemContent {...props} errorMessage={errorMessage} />;
};

const FormItem = (props: IFormItemProps) =>
  props.isNotForm ? (
    <FormItemContent {...props} />
  ) : (
    <FormikFormItem {...props} />
  );

export default FormItem;
